export default class FieldUpdate {
  constructor (schemaField) {
    this.schemaField = schemaField
  }

  setValue(field, value) {
    if(this.schemaField.type=="radio"){
      field.data=this.schemaField.values.find(val=>val.key == value).value
    }else{
      field.data=value
    }
  }
}
